export default function StageSubmissionView({ submissions = [] }) {
  if (!submissions.length) {
    return <div className="small-muted">No submissions yet.</div>;
  }

  const previewUrl = (filePath) =>
    `${process.env.REACT_APP_API_UPLOAD_URL}${filePath}?token=${encodeURIComponent(
      localStorage.getItem("accessToken") || "",
    )}`;

  return (
    <div
      // className="panel"
      style={{
        marginTop: 8,
        display: "flex",
        flexDirection: "column",
        gap: 12,
      }}
    >
      <hr style={{ border: "none", borderTop: "1px solid #e5e7eb" }} />
      <h3>Submissions in Review</h3>
      {submissions.map((submission) => (
        <div
          key={submission.id}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <h4 className="small-muted">{submission.taskTitle}</h4>
            {/* ({submission.taskType}) */}
            {submission.taskType === "text" && (
              <div>{submission.textValue || "-"}</div>
            )}
          </div>

          {submission.taskType === "checkbox" && (
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <span style={{ fontSize: 16 }}>
                {submission.textValue === "true" ? "✅" : "☐"}
              </span>
              <span className="small-muted">
                {submission.textValue === "true"
                  ? "Confirmed"
                  : "Not confirmed"}
              </span>
            </div>
          )}

          {submission.taskType === "file" && submission.filePath && (
            <a
              className="btn-secondary"
              href={previewUrl(submission.filePath)}
              target="_blank"
              rel="noreferrer"
            >
              Preview
            </a>
          )}
        </div>
      ))}
      <hr style={{ border: "none", borderTop: "1px solid #e5e7eb" }} />
    </div>
  );
}
